import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserModel } from '../../models/userModel';
import { ViewUserRolesComponent } from '../view-user-roles/view-user-roles.component';
import { MfgappsEventService } from 'src/app/services/mfgapps-event.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() sidebarCollapsed = false;
  @Input() activeShellNav = 'success';
  @Input() user!: UserModel;
  @Output() toggleCollapse = new EventEmitter<void>();
  @Output() closeMenu = new EventEmitter<void>();
  analyticsExpanded = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dialog: MatDialog,
    private readonly router: Router,
    readonly eventService: MfgappsEventService
  ) {}

  ngOnInit(): void {
    this.analyticsExpanded = this.isAnalyticsRoute(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        this.analyticsExpanded = this.isAnalyticsRoute(event.urlAfterRedirects);
      });
  }

  toggleSidebarCollapse() {
    this.toggleCollapse.emit();
  }

  closeSidebar() {
    this.closeMenu.emit();
  }

  toggleAnalyticsMenu() {
    const nextExpanded = !this.analyticsExpanded;
    this.analyticsExpanded = nextExpanded;
    if (nextExpanded) {
      const landingPage = this.isDevOrLocal() ? 'snapshot' : 'deployment';
      void this.router.navigate(['/analytics', landingPage]);
    }
  }

  isDevOrLocal(): boolean {
    const enabledenvironments = ['dev', 'local', 'qa'];
    return enabledenvironments.includes(this.eventService.environmentName);
  }

  private isAnalyticsRoute(url: string): boolean {
    const normalizedUrl = (url || '').toLowerCase();
    return normalizedUrl.startsWith('/analytics') || normalizedUrl.startsWith('/reporting');
  }

  showUserRoles() {
    this.dialog.open(ViewUserRolesComponent, {
      maxWidth: '80vw',
      maxHeight: '80vh',
      height: '98%',
      width: '98%',
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}